/* eslint-disable prettier/prettier */
import { useState } from 'react';
import { courseService, UpdateCoursePayload } from '../services/courseService';
import { CourseResponse } from '../services/courseService';

interface UseUpdateCourseReturn {
	updateCourse: (
		courseId: string,
		payload: UpdateCoursePayload
	) => Promise<CourseResponse | null>;
	loading: boolean;
	error: string | null;
	success: boolean;
	reset: () => void;
}

export const useUpdateCourse = (): UseUpdateCourseReturn => {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);
	const [success, setSuccess] = useState(false);

	const updateCourse = async (
		courseId: string,
		payload: UpdateCoursePayload
	): Promise<CourseResponse | null> => {
		setLoading(true);
		setError(null);
		setSuccess(false);

		try {
			const response = await courseService.updateCourse(
				courseId,
				payload
			);

			if (!response.success) {
				setError(response.message || 'Failed to update course');
				return null;
			}

			setSuccess(true);
			return response.data;
		} catch (err: any) {
			const message = err?.message || 'Something went wrong';
			setError(message);
			return null;
		} finally {
			setLoading(false);
		}
	};

	const reset = () => {
		setError(null);
		setSuccess(false);
		setLoading(false);
	};

	return {
		updateCourse,
		loading,
		error,
		success,
		reset,
	};
};
